import * as React from "react"
import { Row, Col } from "react-bootstrap"
import { Link, useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

const ProductsComponent = () => {
  const data = useStaticQuery(graphql`
    query {
      api {
        products {
          title
          slug
          icon {
            url
            imageFile {
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  height: 60
                  placeholder: TRACED_SVG
                )
              }
            }
          }
        }
      }
    }
  `)
  return (
    <>
      <Row className="hide-products">
        <Col>
          <div className="title">
            <h3 className="gradient-text">Soluções</h3>
          </div>
          <p>Soluções tecnológicas aplicadas ao seu negócio</p>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md={11}>
          <Row className="products pt-3 no-gutters">
            {data.api.products.map(product => {
              return (
                <Col md={4} key={product.slug}>
                  <Link
                    to={`/produto/${product.slug}`}
                    activeClassName="active"
                  >
                    <div className="product d-flex flex-row align-items-center justify-content-center px-5 m-2">
                      <div className="mr-3">
                        <GatsbyImage
                          image={
                            product.icon.imageFile.childImageSharp
                              .gatsbyImageData
                          }
                          height={60}
                          alt=""
                        />
                      </div>
                      <div style={{ width: 180 }}>
                        <span>{product.title}</span>
                      </div>
                    </div>
                  </Link>
                </Col>
              )
            })}
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default ProductsComponent
